// Assets cars
import image1 from '../../assets/lvls/1.png';
import image2 from '../../assets/lvls/2.png';
import image3 from '../../assets/lvls/3.png';
import image4 from '../../assets/lvls/4.png';
import image5 from '../../assets/lvls/5.png';
import image6 from '../../assets/lvls/6.png';
import image7 from '../../assets/lvls/7.png';
import image8 from '../../assets/lvls/8.png';

export const lvls = [
    {
        rank: 1,
    	name: "Rookie Racer",
    	image: image1,
    	progress: -1,
	},
	{
        rank: 2,
    	name: "Speed Enthusiast",
    	image: image2,
    	progress: 9,
	},
	{
        rank: 3,
    	name: "Track Explorer",
    	image: image3,
    	progress: 15,
	},
	{
        rank: 4,
    	name: "Nitro Prodigy",
    	image: image4,
    	progress: 25,
	},
	{
        rank: 5,
    	name: "Turbo Master",
    	image: image5,
    	progress: 50,
	},
	{
        rank: 6,
    	name: "Race Dominator",
    	image: image6,
    	progress: 60,
	},
	{
        rank: 7,
    	name: "Velocities of Legends",
    	image: image7,
    	progress: 76,
	},
	{
        rank: 8,
    	name: "Ultimate Speedster",
    	image: image8,
    	progress: 85,
	}
];